import { useCallback, useEffect, useState } from "react";
import { ApiFailure } from "./api.ts";

export interface Loaded<T> { data: T | null; error: string | null; loading: boolean; reload: () => void }

export function useLoad<T>(load: () => Promise<T>, deps: unknown[]): Loaded<T> {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    let live = true;
    setLoading(true);
    setData(null);
    setError(null);
    load().then((d) => { if (live) { setData(d); setError(null); } })
      .catch((e: unknown) => { if (live) setError(e instanceof ApiFailure ? e.message : "We could not load this information. Please try again."); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, tick]);
  return { data, error, loading, reload: useCallback(() => setTick((t) => t + 1), []) };
}

export const fmtDay = (iso: string | null | undefined): string => iso ? new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" }) : "—";
export const fmtLong = (iso: string | null | undefined): string => iso ? new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" }) : "—";
export const weekday = (iso: string | null | undefined): string => iso ? new Date(iso).toLocaleDateString("en-AU", { weekday: "long" }) : "";
